import { Component, Inject } from "@angular/core";
import { ActivateScal360LicenseComponent } from "../activate-scal360-license/activate-scal360-license.component";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LicenseService } from "../../../services/LicenseService";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { IBillingShippingModel, SCALType } from "../../../interfaces/LicenseModel";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    template:require('./view-scal360-license-information.component.html'),
    styles:[require('./view-scal360-license-information.component.css')],
    selector:'view-scal360-license-information'
})
export class ViewScal360LicenseInformationComponent{
    dialogTitle='SCAL 360 License Information';
    errorMessage='';
    isRadioButtonDisabled=false;
    selectedRow=null;
    SCALTypeEnum=SCALType;
    billingShippingDetail:IBillingShippingModel={
        ODataEtag:'',
        Number:'',
        publicId:'',
        CustomerNo:'',
        publicSalesPersoncode:'',
        BillToName:'',
        BillToAddress1:'',
        BillToAddress2:'',
        BillToCity:'',
        BillToState:'',
        BillToZipcode:'',
        BillToCountryCode:'',
        ShipToCode:'',
        ShipToName:'',
        ShipToAddress1:'',
        ShipToAddress2:'',
        ShipToCity:'',
        ShipToState:'',
        ShipToZipcode:'',
        ShipToCountryCode:'',
        CustomerTelephone:'',
        CustomerEmailAddress:'',
        CustomerFaxno:'',
        ShippingTelephoneno:'',
        ShippingFaxno:'',
        ShippingEmailAddress:'',
        Rep1:'',
        Rep2:'',
        Sales1:'',
        Sales2:''
    };
    customerId=0;
    shippingAddressId=0;
    shouldFetchSalesOrderNo=false;
    scal360LicenseDisplayList;
    SelectedCustomerLicenseDetail;
    LicenseDetails;
    error="";
    SCALTypeList=[];
    SelectedLicenseKey='';
    isLoading=false;
    constructor(
        private dialogRef:MdDialogRef<ActivateScal360LicenseComponent>,
        private formBuilder:FormBuilder,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private snackBar:MdSnackBar,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData: any
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList=this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail=this.dialogData.SelectedLicenseDetail;
        this.getScalCustomerLicenseDetail();
        this.billingShippingDetail.BillToName=this.SelectedCustomerLicenseDetail.BillToName;
        this.billingShippingDetail.BillToAddress1=this.SelectedCustomerLicenseDetail.BillToAddress1;
        this.billingShippingDetail.BillToAddress2=this.SelectedCustomerLicenseDetail.BillToAddress2;
        this.billingShippingDetail.BillToCity=this.SelectedCustomerLicenseDetail.BillToCity;
        this.billingShippingDetail.ShipToName=this.SelectedCustomerLicenseDetail.ShipToName;
        this.billingShippingDetail.ShipToAddress1=this.SelectedCustomerLicenseDetail.ShipToAddress1;
        this.billingShippingDetail.ShipToAddress2=this.SelectedCustomerLicenseDetail.ShipToAddress2;
        this.billingShippingDetail.ShipToCity=this.SelectedCustomerLicenseDetail.ShipToCity;
        this.billingShippingDetail.ShipToState=this.SelectedCustomerLicenseDetail.ShipToState;
    }
    getScalCustomerLicenseDetail(){
        this.isLoading=true;
        this.licenseService.getScal360CustomerLicenseDetail(this.SelectedCustomerLicenseDetail.LicenseId).subscribe((data)=>{
            if(!data.Error && data.DataObject!=null){
                this.LicenseDetails=data.DataObject
            }
            this.isLoading=false;
        })
    }
    onCancel(){
        this.dialogRef.close(this.scal360LicenseDisplayList);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/scal360/view-scal360-license-information/view-scal360-license-information.component.ts